import * as css from './PlusIconToPop.css';

function PlusIconToPop({show}) {

    return (
        <css.plus onClick={() => show.close()} />
    );
}
export default PlusIconToPop;